export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8080/api/' : 'https://asset.1maintenance.com.au/api/';

// --- Asset identifier display rule (shared across the whole app) ---
// AssetId is the primary identifier; CatNo is shown as the secondary value.
//   • Tight spaces (chips, single-line cells)  -> assetPrimaryLabel  -> "AssetId"
//   • Roomy spaces (option rows, search, headers) -> assetFullLabel  -> "AssetId (CatNo)"
// CatNo stays the internal record key everywhere (form state, equality, payloads) —
// only the *displayed* string changes. AssetId is a required field so it should always
// be present; the CatNo fallback is a defensive safety net only.
// Helpers accept either camelCase (assetId/catNo) or snake_case (asset_id/cat_no) fields.
const _assetId = (a) => (a ? (a.assetId ?? a.asset_id ?? null) : null);
const _catNo = (a) => (a ? (a.catNo ?? a.cat_no ?? null) : null);

export const assetPrimaryLabel = (a) => _assetId(a) || _catNo(a) || '';

export const assetFullLabel = (a) => {
  const id = _assetId(a);
  const cat = _catNo(a);
  if (id && cat) return `${id} (${cat})`;
  return id || cat || '';
};

// --- Module-gating permissions (single source of truth) ---
// A user holding NONE of these has access only to the always-available Assets module,
// i.e. a "scan-only" user. Used by App.js HomeRoute (redirect / → /assets) and
// AppShell (hide Home + Assets nav for these users). Keep this list the only definition.
export const MODULE_PERMS = [
  'canAddAsset', 'canInspectAsset', 'canRegisterUser',
  'canViewSchedule', 'canManageSchedule',
  'canManageWorkshop', 'canUseDetailedInspection', 'canViewPlatformDashboard',
  'canAdminReport', 'canAddDefect',
];

// True if the logged-in user has at least one module permission.
export const userHasModules = () =>
  MODULE_PERMS.some((p) => localStorage.getItem(p) === '1');

// True when running as an installed PWA (home-screen / standalone) rather than a
// browser tab. Offline features work in both, but installed storage is far less
// likely to be evicted, so it surfaces a durability tip. Never used to gate features.
export const isStandalone = () => {
  try {
    return window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
  } catch (_) {
    return false;
  }
};
